import type { SequenceDocument, SequenceEvent, TrackType } from '../format/types';

export interface ProjectState {
  readonly patterns: readonly SequenceDocument[];
  readonly activePatternId: string;
}

export type ProjectAction =
  | { readonly type: 'LOAD_PROJECT'; readonly project: ProjectState }
  | { readonly type: 'NEW_PATTERN' }
  | { readonly type: 'DUPLICATE_PATTERN'; readonly patternId: string }
  | { readonly type: 'RENAME_PATTERN'; readonly patternId: string; readonly name: string }
  | { readonly type: 'DELETE_PATTERN'; readonly patternId: string }
  | { readonly type: 'SELECT_PATTERN'; readonly patternId: string }
  | { readonly type: 'SET_BPM'; readonly bpm: number }
  | { readonly type: 'SET_LENGTH_STEPS'; readonly lengthSteps: number }
  | { readonly type: 'SET_LOOP'; readonly loop: boolean }
  | { readonly type: 'SET_SWING'; readonly swing: number }
  | { readonly type: 'ADD_TRACK' }
  | { readonly type: 'REMOVE_TRACK'; readonly trackId: string }
  | { readonly type: 'RENAME_TRACK'; readonly trackId: string; readonly name: string }
  | { readonly type: 'SET_TRACK_TYPE'; readonly trackId: string; readonly trackType: TrackType }
  | { readonly type: 'SET_TRACK_ROLE'; readonly trackId: string; readonly role: string }
  | { readonly type: 'SET_TRACK_MUTE'; readonly trackId: string; readonly mute: boolean }
  | { readonly type: 'SET_TRACK_SOLO'; readonly trackId: string; readonly solo: boolean }
  | { readonly type: 'SET_TRACK_LEVEL'; readonly trackId: string; readonly level: number }
  | { readonly type: 'CLEAR_TRACK'; readonly trackId: string }
  | { readonly type: 'CLEAR_PATTERN' }
  | { readonly type: 'TOGGLE_STEP'; readonly trackId: string; readonly step: number; readonly eventId?: string }
  | { readonly type: 'UPDATE_EVENT'; readonly eventId: string; readonly patch: Record<string, unknown> }
  | { readonly type: 'REMOVE_EVENT'; readonly eventId: string }
  | { readonly type: 'REPLACE_ACTIVE_PATTERN'; readonly document: SequenceDocument }
  | { readonly type: 'IMPORT_AS_NEW_PATTERN'; readonly document: SequenceDocument };

export interface ImportOutcome {
  readonly ok: boolean;
  readonly project?: ProjectState;
  readonly errors?: readonly { readonly path: string; readonly message: string }[];
}

export function findActivePattern(state: ProjectState): SequenceDocument | undefined {
  return state.patterns.find((pattern) => pattern.id === state.activePatternId);
}

export function findEventById(events: readonly SequenceEvent[], eventId: string): SequenceEvent | undefined {
  return events.find((event) => event.id === eventId);
}
